import React from "react";
import { Link } from "react-router-dom";
import { Brain } from "@phosphor-icons/react";

export const Footer = () => (
    <footer className="border-t border-slate-200 bg-white mt-16">
        <div className="max-w-[1400px] mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">
            <div>
                <div className="flex items-center gap-2 mb-3">
                    <div className="w-7 h-7 bg-slate-950 flex items-center justify-center">
                        <Brain size={16} color="#fff" weight="duotone" />
                    </div>
                    <span className="font-display text-lg">
                        Jobs<span className="text-blue-600">IQ</span>
                    </span>
                </div>
                <p className="text-slate-600">
                    Deep-learning recruitment intelligence. Matching minds, not just keywords.
                </p>
            </div>
            <div>
                <div className="font-mono-plex text-xs uppercase tracking-widest text-slate-500 mb-3">For talent</div>
                <ul className="space-y-1.5">
                    <li><Link to="/jobs" className="hover:text-blue-600">Browse jobs</Link></li>
                    <li><Link to="/chatbot" className="hover:text-blue-600">AI skill coach</Link></li>
                    <li><Link to="/video-interview" className="hover:text-blue-600">Video interview</Link></li>
                </ul>
            </div>
            <div>
                <div className="font-mono-plex text-xs uppercase tracking-widest text-slate-500 mb-3">For teams</div>
                <ul className="space-y-1.5">
                    <li><Link to="/register" className="hover:text-blue-600">Post a job</Link></li>
                    <li><Link to="/register" className="hover:text-blue-600">AI match engine</Link></li>
                    <li><Link to="/register" className="hover:text-blue-600">Candidate analysis</Link></li>
                </ul>
            </div>
            <div>
                <div className="font-mono-plex text-xs uppercase tracking-widest text-slate-500 mb-3">Index</div>
                <ul className="space-y-1.5 font-mono-plex text-xs text-slate-600">
                    <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-blue-600">Privacy Policy</Link></li>
                    <li><Link data-testid="footer-terms" to="/terms" className="hover:text-blue-600">Terms &amp; Conditions</Link></li>
                    <li><Link data-testid="footer-contact" to="/contact" className="hover:text-blue-600">Contact us</Link></li>
                    <li>All rights reserved</li>
                </ul>
            </div>
        </div>
    </footer>
);

export default Footer;
